/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
/* tslint:disable */
// @ts-nocheck
// What's with all the above disables?
//  this is what a legacy 7 year old codebase looks like.
import { Grid } from '@elliemae/ds-grid';
import { __UNSAFE_SPACE_TO_DIMSUM, op, styled, useTheme } from '@elliemae/ds-system';
import { DSFullPageContainer } from '../FullPageContainer/index.js';

const Header = styled(Grid)`
  border-bottom: 1px solid ${(props) => props.theme.colors.neutral['300']};
`;
const ButtonSlot = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Title = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 22px;
`;
const BreadCrumb = styled(Grid)`
  align-items: flex-end;
  font-size: 16px;
  color: ${(props) => props.theme.colors.neutral[500]};
`;
const Body = styled(Grid)`
  margin: 0 auto;
  width: 100%;
  overflow: auto;
`;
const Footer = styled(Grid)`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  padding: 0.67rem;
  border-top: 1px solid ${(props) => props.theme.colors.neutral[300]};

  & > button {
    flex-grow: 1;
    margin: 0 0.33rem;
  }
`;

const PageFilter = ({
  children = null,
  breadCrumb = null,
  pageTitle = null,
  leftProp = null,
  rightProp = null,
  footerButton = null,
}) => {
  const theme = useTheme();
  const headerDimension = theme.space.l;
  const rows = [headerDimension, 1];
  if (footerButton) rows.push(op('*', __UNSAFE_SPACE_TO_DIMSUM(theme.space.xl), 1.167));
  const cols = ['auto'];
  if (leftProp) cols.unshift(headerDimension);
  if (rightProp) cols.push(headerDimension);
  const bodyStyle = {
    maxWidth: op('*', __UNSAFE_SPACE_TO_DIMSUM(theme.space.xxl), 6.25),
  };
  return (
    <DSFullPageContainer rows={rows}>
      <Header cols={cols} height={headerDimension}>
        {leftProp && <ButtonSlot ml={__UNSAFE_SPACE_TO_DIMSUM(theme.space.s)}>{leftProp}</ButtonSlot>}
        <Grid>
          {breadCrumb && <BreadCrumb pl={!leftProp && '1rem'}>{breadCrumb}</BreadCrumb>}
          <Title style={leftProp ? {} : { paddingLeft: '1rem' }}>{pageTitle}</Title>
        </Grid>
        {rightProp && <ButtonSlot ml={__UNSAFE_SPACE_TO_DIMSUM(theme.space.s)}>{rightProp}</ButtonSlot>}
      </Header>

      <Body style={bodyStyle}>{children}</Body>
      {footerButton && <Footer>{footerButton}</Footer>}
    </DSFullPageContainer>
  );
};

const DSPageFilter = PageFilter;

export { DSPageFilter };
